// Local Storage Keys USED
const LS_KEYS = Object.freeze({
  VISITED_URL_LIST: 'SmoothrVisitedUrls',
  VISITED_ROUTE_LIST: 'SmoothrVisitedRoutes'
});

export { LS_KEYS };